import { URLS } from '../../../constants';
import apiClient from '../../client';

const CoSign = {
  getNotification: ({ userSpecificId, type }: { userSpecificId: any; type: string }) =>
    apiClient.post(URLS.getNotification, {
      data: {
        userSpecificId,
        type,
      },
    }),
  technicianNotification: ({ type }: { type: any }) =>
    apiClient.post(URLS.technicianAvailabilityNotification, {
      data: { type },
    }),
  acknowledgeNorification: ({ id }: { id: any }) =>
    apiClient.post(URLS.acknowledgeNotification, {
      data: { id },
    }),
  addBulkCosign: ({ cosignedBy, coSignData }: { cosignedBy: any; coSignData: any }) =>
    apiClient.post(URLS.addBulkCosign, {
      data: { cosignedBy, coSignData },
    }),
  getSessionNoteData: ({ ids }: { ids: any[] }) =>
    apiClient.post(URLS.getSessionNoteData, {
      data: { ids },
    }),
  getAudutingNotification: ({ type }: { type: any }) =>
    apiClient.post(URLS.getAuditingNotification, {
      data: { type },
    }),
};

export default CoSign;
